exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ace-editor div,\n.ace-editor span {\n  font-family: monospace !important;\n}\n.ace-editor > div.ace_gutter {\n  z-index: 0;\n}\n", ""]);

